(ns basic-components.inputs.link
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [common.entity :as entity]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [reagent.core :as r]))


(defn render
  [args]
  (let [{:keys [:state-atom :value :class-name :entity-id
                :has-focus?
                :on-focus! :on-blur! :on-change!
                :on-key-down! :disabled?]}
        args
        entity (get @session/entities entity-id)
        zap-ent (get @session/entities value)
        ;;if entity not found, link to self
        ;; (handles the case where :asset/name is a link in deal-viewer inside
        ;;  company-information module)
        zap-ent (if zap-ent
                  zap-ent
                  entity)]
    [:a
     {:href     "#"
      :on-click (fn [e]
                  (routing/open-entity (:db/id zap-ent))
                  (.preventDefault e)
                  (.stopPropagation e))}
     (or (entity/resolve-entity-name zap-ent session/get-entity session/reverse-lookup)
         (entity/display-string zap-ent))]))

(defmethod editor :editor.type/link
  [args]
  ;; ref vs atom
  (r/create-class
   {:display-name   "Link"
    :reagent-render (fn [args]
                      (render args))}))

(defmethod display-string :editor.type/link
  [args]
  (let [value (:value args)]
    (cond
      (string? value)
      value

      (= (:value-type args) :entity)
      (or (entity/resolve-entity-name (get @session/entities value) session/get-entity session/reverse-lookup)
          (entity/display-string (get @session/entities value)))

      :else
      (str value))))

(defmethod viewer :editor.type/link
  [args]
  (r/create-class
   {:display-name   "link/viewer"
    :reagent-render (fn [args]
                      (let [value (:value args)]
                        [:div.preview.preview-link
                         (when-not (or (nil? value) (and (string? value) (empty? value)))
                           [:a
                            {:href     "#"
                             :on-click (fn [e]
                                         (routing/open-entity value)
                                         (.preventDefault e)
                                         (.stopPropagation e))}
                            (display-string args)])]))}))
